<template>
  <div>
    <v-btn
      v-if="joboffer.pitchYouApplyUrl"
      :href="joboffer.pitchYouApplyUrl"
      target="_blank"
      class="mr-2 px-6 mb-2 whatsapp-button"
      :aria-label="$t('application.applyWithWhatsapp')"
      @click="trackCta(joboffer.jobofferId, 'pitchyou')"
    >
      <v-icon>mdi-whatsapp</v-icon>
      <span class="ml-2" v-if="!dense">
        {{ $t('application.applyWithWhatsapp') }}
      </span>
    </v-btn>

    <v-btn
      v-if="joboffer.hasExternalApplicationForm"
      :href="joboffer.applyUrl"
      target="_blank"
      class="mr-2"
      @click="trackCta(joboffer.jobofferId, 'external_url')"
    >
      {{ $t('jobs.applyNow') }}
      <v-icon class="ml-2">mdi-send</v-icon>
    </v-btn>

    <apply-dialog
      v-else-if="joboffer.hasShortApplicationForm"
      :joboffer="joboffer"
      inlineButton
    />

    <v-btn
      v-else
      class="mr-2"
      :to="{ name: 'apply', params: { jobofferId: joboffer.jobofferId } }"
      @click="trackCta(joboffer.jobofferId, 'normal_form')"
    >
      {{ $t('jobs.applyNow') }}
      <v-icon class="ml-2">mdi-send</v-icon>
    </v-btn>

    <template v-if="hasLinkToJobportal">
      <v-btn
        v-if="!customLinkToJobportal || customLinkToJobportal === ''"
        :to="{ name: 'jobs' }"
      >
        {{ $t('jobs.moreJoboffers') }}
      </v-btn>

      <v-btn v-else :href="customLinkToJobportal">
        {{ $t('jobs.moreJoboffers') }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import applyDialog from '@/components/application/apply-dialog.vue';
import TrackingService from '@/services/TrackingService.js';

export default {
  props: {
    joboffer: {
      type: Object,
      required: true
    },

    dense: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    ...mapState('companyModule', {
      hasLinkToJobportal: 'hasLinkToJobportal',
      customLinkToJobportal: 'customLinkToJobportal'
    })
  },

  methods: {
    trackCta(jobId, ctaType) {
      TrackingService.trackApplyCta(jobId, ctaType);
    }
  },

  components: {
    applyDialog
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 360px) {
  .whatsapp-button {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
